import { Empty } from "antd"
import NotFoundImg from "images/zwsj.png"
import NotFoundImgW from "images/zwsjw"
import { DeviceContext } from "libs/contexts"
import { webps } from "libs/imgs"
import { ReactNode, useContext } from "react"
import { Image } from "react-vant"
import { cls } from "reactutils"
import QuickNav from "./QuickNav"

webps[NotFoundImg] = NotFoundImgW

export default function NoData({
  height,
  text = "暂无数据",
  img = NotFoundImg,
  showNav,
  customStyle,
  operatingArea,
  nodata = true,
}: {
  height?: string
  text?: string
  img?: string
  showNav?: boolean
  customStyle?: string
  operatingArea?: ReactNode
  nodata?: boolean
}) {
  const { buildImgSrc } = useContext(DeviceContext)

  return (
    <>
      <div className={cls("container", customStyle)}>
        <div className="notfound">
          {nodata ? (
            <Empty description={false} />
          ) : (
            <Image className="img" src={buildImgSrc(img)} width={120} alt="" />
          )}
          <p>{text}</p>
          {operatingArea}
        </div>
      </div>
      {showNav && <QuickNav />}
      <style jsx>{`
        .container {
          height: ${height ? height : "calc(100vh - 115px)"};
        }

        .notfound {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 140px;
        }

        .img {
          width: 130px;
          height: 130px;
        }

        .notfound p {
          font-size: 15px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 8px;
        }
      `}</style>
    </>
  )
}
